export type BoitageDocumentKind = 'stop-pub' | 'sans-stop-pub';

export type BoitageWindow = {
  year: number;
  eventIndex: 1 | 2;
  plannedLabel: string;
  plannedDate: string; // YYYY-MM-DD
  docsPlanned: number;
  executedAt: string | null;
  documents: Record<BoitageDocumentKind, boolean>;
};

export const BOITAGE_STATUS = {
  PLANNED: 'planned',
  DONE: 'done',
  SKIPPED: 'skipped',
} as const;

export type BoitageStatus = typeof BOITAGE_STATUS[keyof typeof BOITAGE_STATUS];

export type BoitageAssignment = {
  id: number;
  coproId: number;
  cycleYear: number;
  eventIndex: 1 | 2;
  plannedDate: string | null;
  plannedLabel: string | null;
  docsPlanned: number;
  status: BoitageStatus;
  executedAt: string | null;
};


